export const ReviewPhase = {
	none: 0,
	reflecting: 1,
	iterating: 2
}